import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useCallback,
} from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import DataTableBase from "../common/DataTableBase";
// import PageNavbar from "./PageNavbar";
import ApproveToolbox from "./ApproveToolbox";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import SlidingDrawer from "../common/SlidingDrawer";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { Button as PrimeButton } from "primereact/button";
import CustomDialog from "../common/CustomDialog";
import _ from "lodash";
import { capitalizeLeadingText } from "../../utils/textFormat";
import { useLocation } from "react-router-dom";
// import filingMasters from "../../data/filingMasters.json";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import ClientFilingMasterContext from "../../context/client-filing-master/ClientFilingMasterContext";
import ApproveClientFilingMaster from "./ApproveClientFilingMaster";
import ClientFilingMasterWorkflowComments from "./ClientFilingMasterWorkflowComments";
import ReactLoading from "react-loading";
import AuthContext from "../../context/auth/AuthContext";
import { Stack } from "@mui/material";
import axios from "axios";
import { DateTime } from "luxon";
import IconButton from "@mui/material/IconButton";
import InsertCommentRoundedIcon from "@mui/icons-material/InsertCommentRounded";
import ClientFilingMasterReferenceDocuments from "./ClientFilingMasterReferenceDocuments";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { CircularProgress } from "@mui/material";
import { Box, Popover, MenuItem } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import states from "../../data/StateLookup.json";
import { Dropdown } from "primereact/dropdown";
import { tokens } from "../../theme/tokens";
import { TrackNowButton } from "../ui/TrackNowButton";
import { TextField, InputAdornment } from "@mui/material";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { useResponsive } from "../hooks/useResponsive";
import { useCommonDetailsContext } from "../../context/Common/common";

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ClientFilingMasterApprovalList = () => {
  const { isMobile, mdUp } = useResponsive();
  const { publishedBranding } = useCommonDetailsContext();
  const tableHeaderColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const containerBackgroundColor = tokens.colors.offWhite;
  const tableBackgroundColor = containerBackgroundColor;
  const enableForzen = !isMobile
  const [selectedFiling, setSelectedFiling] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [data, setData] = useState([]);
  const [clientApprovalList, setClientApprovalList] = useState([]);
  const [federalFilterSelectedValues, setFederalFilterSelectedValues] =
    React.useState({
      federalCategories: [],
    });
  const [attachments, setAttachments] = React.useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [federalCategoriesLookup, setFederalCategoriesLookup] = useState([]);
  const [stateCategoriesLookup, setStateCategoriesLookup] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [comments, setComments] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    approverName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // dueDayofFrequency: { value: null, matchMode: FilterMatchMode.IN },
    stateInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },

    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    // jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // jsicontactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
  });
  const [stateArray, setStateArray] = useState([]);

  const authContext = useContext(AuthContext);
  const { roleType, authId, authUser, toLocalDateTime } = authContext;

  const filingMasterContext = useContext(FilingMasterContext);
  const { getBusinessCategories } = filingMasterContext;

  const getFilingCategories = (filingMaster) => {
    return _.map(filingMaster.businessCategory, "businessCategoryName").join(
      ", "
    );
  };

  // const filingMasterContext = useContext(FilingMasterContext);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const [viewAll, setViewAll] = useState(true);
  // const {
  // getClientFilingMastersApprovalList,
  // ClientFilingMasterApprovals,
  // ClientFilingMasterLoaded,
  // getClientFilingMasterWorkflowComments,
  // } = filingMasterContext;

  const {
    getClientFilingMastersApprovalList,
    setClientFilingMastersApprovalList,
    ClientFilingMasterApprovals,
    ClientFilingMasterLoaded,
    getClientFilingMasterWorkflowComments,
  } = clientFilingMasterContext;

  // const data = ClientFilingMasterApprovals;
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [showFilter, setShowFilter] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [jurisdiction, setJurisdiction] = useState([]);
  const [expandedRows, setExpandedRows] = useState(null);
  const [filingPeriodTable, setFilingPeriodTable] = useState([]);
  const [categoryList, setCategoryList] = useState([])
  const [isClearIcon, setIsClearIcon] = useState(false);

  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [selectedFilterColumn, setSelectedFilterColumn] = useState("");
  const [selectedFilterCondition, setSelectedFilterCondition] = useState("");
  const [selectedFilterValue, setSelectedFilterValue] = useState("");

  const allowedFilterColumns = [
    "approverName",
    "filingName",
    "customerName",
    "filingFrequency",
    "stateList",
    "ruleInfo",
    "required",
    "federalCategories",
    "stateCategories",
    "jsicontactName",
    "juristiction",
  ];

  const filterableColumns = [
    { value: "approverName", label: "Approver Name" },
    { value: "filingName", label: "Filing Name" },
    { value: "customerName", label: "Client Name" },
    { value: "filingFrequency", label: "Filing Frequency" },
    { value: "stateList", label: "State" },
    { value: "ruleInfo", label: "Rule Info" },
    { value: "required", label: "Mandatory" },
    { value: "federalCategories", label: "Who Must File Federal" },
    { value: "stateCategories", label: "Who Must File in State" },
    { value: "jsicontactName", label: "JSI Staff" },
    { value: "juristiction", label: "Jurisdiction" },
  ];

  const displayFilter = () => {
    console.log("Toggling Show Filter", showFilter);
    setShowFilter(() => true);
  };
  const closeFilter = () => {
    console.log("Toggling Show Filter", showFilter);
    setShowFilter(() => false);
  };
  const handleViewAllClick = () => {
    setViewAll(true);
  };

  const handlePaginationClick = () => {
    setViewAll(false);
  };

  // const location = useLocation()
  // const { selectRows } = location.state;
  // console.log("received props", selectRows);

  const approveDraft = () => {
    console.log("Approving Draft", selectedFiling);
    if (selectedFiling && selectedFiling.length !== 0) {
      setShowFilter(() => true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };
  const fetchFilingMasterAttachments = async (filingId) => {
    console.log("fetchFilingMasterAttachments props", filingId);
    try {
      const attachmentList = await axios.get(
        `${API_BASE_URL}/FilingMaster/FilingMasterAttachments/${filingId}`
      );
      setAttachments(() => attachmentList.data.data);
      console.log("fetchFilingMasterAttachments res", attachmentList);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };
  const closeAttachments = () => {
    console.log("Toggling Show Filter", showAttachments);
    setShowAttachments(() => false);
  };
  const displayAttachments = async (rowData) => {
    console.log("##selectedFiling", selectedFiling[0]);
    console.log("##RowData", rowData);
    console.log("LengthSelectedFiling", selectedFiling.length);
    if (rowData && rowData.filingId) {
      console.log(`##RowData-FilingId :${rowData.filingId}`);
      fetchFilingMasterAttachments(rowData.filingId);
      setShowAttachments(() => true);
      setSelectedFiling(() => []);
    } else if (
      selectedFiling &&
      selectedFiling.length === 1 &&
      selectedFiling[0].filingId
    ) {
      console.log(`Fetching Attachment for :${selectedFiling[0].filingId}`);
      fetchFilingMasterAttachments(selectedFiling[0].filingId);
      setShowAttachments(() => true);
      setSelectedFiling(() => []);
    } else if (selectedFiling.length > 1) {
      setAlertMessage("Please Select a single Filing Master Record");
      setShowAlert(true);
    } else {
      setAlertMessage("Please Select a Filing Master Record");
      setShowAlert(true);
    }
  };

  const fetchFilingMasterComments = async (filingId) => {
    console.log(
      "@@Fetch FilingMasters1:",
      getClientFilingMasterWorkflowComments
    );
    if (getClientFilingMasterWorkflowComments) {
      console.log("@@Fetch FilingMasters2:");
      try {
        const commentList = await getClientFilingMasterWorkflowComments(
          filingId
        );
        setComments(() => commentList);
        console.log("@@Fetch FilingMasters2 comments:", commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const addComment = (rowData) => {
    console.log("Display Comments", selectedFiling);
    console.log("Display Comments rowData", rowData);
    if (rowData && rowData.workflowId) {
      console.log(`Fetching Commnet for :${rowData.workflowId}`);
      console.log(`Fetching Commnet for rowData :${rowData}`);
      fetchFilingMasterComments(rowData.workflowId);
      setShowComments(() => true);
      setSelectedRowData(rowData);
    } else if (
      selectedFiling &&
      selectedFiling.length === 1 &&
      selectedFiling[0].workflowId
    ) {
      console.log(`Fetching Commnet for :${selectedFiling[0].workflowId}`);
      setSelectedRowData(null);
      fetchFilingMasterComments(selectedFiling[0].workflowId);
      setShowComments(() => true);
    } else {
      setAlertMessage("Please select a single Record");
      setShowAlert(true);
    }
  };

  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : stateCode;
  };

  const closeComments = () => {
    console.log("Toggling Show Filter", showComments);
    setShowComments(() => false);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const jusrisdictionItemTemplate = (option) => {
    return (
      <div className="flex align-items-center">
        <span>{option}</span>
      </div>
    );
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    // console.log("##Options4:", options);
    // console.log("##Options:", options, "matchmode", options.filterModel.matchMode,);
    console.log("federalFilterSelectedValuesCheck", federalFilterSelectedValues);
    if (!federalFilterSelectedValues?.jurisdiction && options?.filterModel?.value) {
      console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }
    return (
      <Dropdown
        value={federalFilterSelectedValues.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />)
  };

  const mandatoryArray = ["True", "False"];

  const mandatoryRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!federalFilterSelectedValues.mandatory && options?.filterModel?.value) {
      // console.log("requiredRowFilterTemplate filterModel",options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={federalFilterSelectedValues.mandatory || []}
        options={mandatoryArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, mandatory: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };


  const fetchFilingMasters = async () => {
    console.log("@@Fetch FilingMasters1:", getClientFilingMastersApprovalList);
    if (getClientFilingMastersApprovalList) {
      setIsLoading(true)
      console.log("@@Fetch FilingMasters2:");
      try {
        let formData;
        if (roleType?.includes("Admin")) {
          formData = {
            recordType: "TrackNow"
          };
        }
        else {
          formData = {
            approverId: authUser.userId,
            recordType: "TrackNow",
          }
        }
        const list = await getClientFilingMastersApprovalList(formData);

        console.log("Indcheck FilingMasters", "list", list);
        console.log("@@FilingMasters:", list);
      } catch (error) {
        console.log("@@Error:", error);
      } finally {
        setIsLoading(false)
      }
    }
  };

  const onRowSelect = (e) => {
    console.log("@@RowSelect:", e);
  };

  useEffect(() => {
    // console.log("Show Table Data ff", ClientFilingMasterApprovals);
    if (ClientFilingMasterApprovals) {
      // console.log("Show Table Data", ClientFilingMasterApprovals);
      // let fedLookup = [];
      // const updList = ClientFilingMasterApprovals?.filter(
      //   (item) => item.workflowStatus === "Pending"
      // ).map((item) => {
      //   console.log(`filtered data ...`, item);
      //   const _stateList = getStateName(item.stateInfo);

      //   if (item.juristiction?.includes("Federal")) {
      //     const categories = _.map(
      //       item.businessCategory,
      //       "businessCategoryName"
      //     ).join(", ");
      //     // console.log(`filingMasters ${item.filingMasters} cat...`, categories);
      //     fedLookup.push(...categories);
      //     return {
      //       ...item,
      //       federalCategories: categories,
      //       stateList: _stateList,
      //     };
      //   } else {
      //     // console.log(
      //     //   "stateCategories: props",
      //     //   item.stateInfo,
      //     //   item.businessCategory
      //     // );
      //     const categoriesState = item.businessCategory.filter((ele) =>
      //       ele.state ? ele.state === item.stateInfo : ele
      //     );
      //     // console.log(
      //     //   "stateCategories: filter",
      //     //   item.filingName,
      //     //   categoriesState
      //     // );
      //     const categories = categoriesState
      //       .map((ele) => ele.businessCategoryName)
      //       .join(", ");

      //     // console.log(`filingMasters ${item.filingMasters} cat...`, categories);

      //     return {
      //       ...item,
      //       stateCategories: categories,
      //       stateList: _stateList,
      //     };
      //   }
      // });
      // const _jusrisdictions = updList.map((item) =>
      //   item.juristiction ? item.juristiction : ""
      // );
      // const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
      // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
      // console.log("Indcheck use", "updList", updList);
      // setJurisdiction(_uniqJurisdictions);
      // setData(() => updList);
      // setClientApprovalList(updList);
      // setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
    }

    //eslint-disable-next-line
  }, [ClientFilingMasterApprovals]);
  console.log("DataTable data", clientApprovalList);

  const fetchBusinessCategories = async () => {
    console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      console.log("@@Fetch BusinessCategories:");
      try {
        let list = []
        const resList = await getBusinessCategories();
        console.log("@@BusinessCategories:", resList);
        list = resList
          .map((item) => item.businessCategoryName)
          .filter(Boolean)
        list.sort()
        console.log("@@BusinessCategories: list", list);
        setCategoryList(() => list);
        // Keep federal/state filter lookups API-driven (same as stage behavior).
        setFederalCategoriesLookup(() => list);
        setStateCategoriesLookup(() => list);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  useEffect(() => {
    let list = states.map((ele) => ele.state);
    setStateArray(list);
    fetchBusinessCategories();
    // fetchFilingMasters();
    setRecordsInView(0);
    setIsLoading(true);
    setData([]);
    setClientApprovalList([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setFederalFilterSelectedValues([]);
    setRefreshRecordList(true);
    //eslint-disable-next-line
  }, []);

  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  useEffect(() => {
    console.log("state", selectedRows);
  }, [selectedRows]);

  const search = useRef();
  const overlayRefs = useRef({});

  const applyGlobalFilter = () => {
    console.log("applyGlobalFilter", search.current.value, isClearIcon)
    let _filters = { ...filters };
    if (isClearIcon) {
      search.current.value = "";
      _filters["global"].value = "";
      setIsClearIcon(false);
      onFilterChange({ filters });
    } else {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
      onFilterChange({ filters });
    }
    setFilters(_filters);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
    setSelectedFilterColumn("");
    setSelectedFilterCondition("");
    setSelectedFilterValue("");
  };

  const handleFilterApply = (filterConfig) => {
    console.log("Filter applied:", filterConfig);
    if (!allowedFilterColumns.includes(filterConfig.field)) {
      return;
    }

    const newFilter = {
      ...filterConfig,
      id: Date.now()
    };
    // setActiveFilters([...activeFilters, newFilter]);
    //Remove duplicate filters with the same field name
    const filteredActiveFilters = activeFilters.filter(
      (f) => f.field !== filterConfig.field
    );

    setActiveFilters([...filteredActiveFilters, newFilter]);
    let _filters = { ...filters };
    if (filterConfig.field && _filters[filterConfig.field]) {
      _filters[filterConfig.field].constraints[0].value = filterConfig.value;
      _filters[filterConfig.field].constraints[0].matchMode = filterConfig.matchMode;
      setFilters(_filters);
      onFilterChange({ filters: _filters });
    }
  };

  const applyFilterFromPopover = () => {
    const hasFilterValue = Array.isArray(selectedFilterValue)
      ? selectedFilterValue.length > 0
      : !!selectedFilterValue;

    if (!selectedFilterColumn || !selectedFilterCondition || !hasFilterValue) {
      return;
    }

    const normalizedMatchMode =
      shouldUseMultiSelectFilterValue(selectedFilterColumn, selectedFilterCondition) &&
        selectedFilterCondition === FilterMatchMode.CONTAINS
        ? FilterMatchMode.IN
        : selectedFilterCondition;

    handleFilterApply({
      field: selectedFilterColumn,
      matchMode: normalizedMatchMode,
      value: selectedFilterValue,
      matchModeLabel:
        normalizedMatchMode === FilterMatchMode.NOT_CONTAINS
          ? "is not"
          : normalizedMatchMode === FilterMatchMode.EQUALS
            ? "is"
            : "contains",
    });

    handleFilterClose();
  };

  const handleFilterClear = () => {
    setActiveFilters([]);
    setSelectedFilterColumn("");
    setSelectedFilterCondition("");
    setSelectedFilterValue("");
    setFilters({
      ...filters,
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setFederalFilterSelectedValues([]);
    setRecordsInView(0);
    setIsLoading(true);
    setData([]);
    setClientApprovalList([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setRefreshRecordList(true);
  };

  const removeFilter = (filterId) => {
    const filterToRemove = activeFilters.find(f => f.id === filterId);
    setActiveFilters(activeFilters.filter(f => f.id !== filterId));

    if (filterToRemove) {
      let _filters = { ...filters };
      if (filterToRemove.field && _filters[filterToRemove.field]) {
        _filters[filterToRemove.field].constraints[0].value = null;
        setFilters(_filters);
        onFilterChange({ filters: _filters });
      }
    }
  };

  const getFilterValueOptions = (column) => {
    if (column === "required") return ["True", "False"];
    if (column === "juristiction") return ["Federal", "State", "Both"];
    if (column === "stateList") return stateArray || [];
    if (column === "federalCategories")
      return (categoryList && categoryList.length > 0
        ? categoryList
        : federalCategoriesLookup) || [];
    if (column === "stateCategories")
      return (categoryList && categoryList.length > 0
        ? categoryList
        : stateCategoriesLookup) || [];
    return [];
  };

  const shouldUseMultiSelectFilterValue = (field, condition) =>
    (field === "stateList" && condition === FilterMatchMode.CONTAINS) ||
    (field === "federalCategories" && condition === FilterMatchMode.CONTAINS) ||
    (field === "stateCategories" && condition === FilterMatchMode.CONTAINS);

  const shouldUseRadioFilterValue = (field, condition) =>
    (field === "stateList" &&
      (condition === FilterMatchMode.EQUALS || condition === FilterMatchMode.NOT_CONTAINS)) ||
    (field === "required" && condition === FilterMatchMode.EQUALS) ||
    (field === "juristiction" && condition === FilterMatchMode.EQUALS) ||
    ((field === "federalCategories" || field === "stateCategories") &&
      (condition === FilterMatchMode.EQUALS || condition === FilterMatchMode.NOT_CONTAINS));

  const getFilterChipLabel = (field) => {
    const configuredLabel = filterableColumns.find((col) => col.value === field)?.label;
    if (configuredLabel) {
      return configuredLabel;
    }

    return String(field || "")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const renderHeader = () => {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
          background: containerBackgroundColor,
          p: 2,
          borderRadius: "8px",
        }}
      >
        {/* TITLE */}
        <Grid item xs={12}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              color: tableHeaderColor,
              display: "flex",
              alignItems: "center",
            }}
          >
            CLIENT FILING MASTER APPROVALS ({totalRecords})
          </Typography>
        </Grid>

        {/* FILTER + CHIPS */}
        <Grid item xs={12} md={7}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
              sx={{
                fontSize: "12px",
                padding: "4px 12px",
                minHeight: "28px",
              }}
            >
              + Filter
            </TrackNowButton>

            {activeFilters.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {activeFilters.map((filter) => (
                  <Box
                    key={filter.id}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      backgroundColor: containerBackgroundColor,
                      border: "1px solid #ccc",
                      borderRadius: "20px",
                      padding: "6px 12px",
                      fontSize: "13px",
                      color: "#333",
                    }}
                  >
                    {getFilterChipLabel(filter.field)}:{" "}
                    {Array.isArray(filter.value)
                      ? filter.value.join(", ")
                      : filter.value}

                    <button
                      type="button"
                      onClick={() => removeFilter(filter.id)}
                      style={{
                        marginLeft: "6px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                      }}
                    >
                      ×
                    </button>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Grid>

        {/* SEARCH */}
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "flex-start", md: "flex-end" },
            }}
          >
            <TextField
              inputRef={search}
              placeholder="Search by Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 260 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: containerBackgroundColor,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} edge="end" size="small">
                      {isClearIcon ? (
                        <GoogleMaterialIcon name="clear" size={20} />
                      ) : (
                        <GoogleMaterialIcon name="search" size={20} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>
      </Grid>
    );
  };
  const header = renderHeader();
  const federalFilterElement = (options, field) => {
    console.log("##OptionsCheck", options, field);
    // let optionsList = [];
    // data
    //   .map((item) => item[field])
    //   .filter(Boolean)
    //   .map((item) => {
    //     if (item.includes(",")) {
    //       //console.log("spliited_item", item);
    //       item.split(",").map((subItem) => {
    //         optionsList.push(subItem && subItem.trim());
    //       });
    //     } else {
    //       optionsList.push(item.trim());
    //     }
    //   });
    // optionsList = optionsList
    //   .filter((item, i) => {
    //     return i === optionsList.lastIndexOf(item);
    //   })
    //   .sort();

    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##federalFilterElement#:", options, e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##federalFilterElement#:", options, e, data);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    console.log("##Options:", options);
    // if (!federalFilterSelectedValues.hasOwnProperty("stateList")) {
    //   options.filterCallback("");
    // }
    if (!federalFilterSelectedValues.stateList && options?.filterModel?.value) {
      console.log(" optionsfilterModel", options.filterModel);
      options.filterModel.value = null;
      options.value = null;
    }
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={federalFilterSelectedValues.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    ) : (
      <Dropdown
        value={federalFilterSelectedValues.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##EOptions:", e);
          setFederalFilterSelectedValues((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "13rem" }}
      />
    );
  };

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const rowElement = cellElement?.closest("tr");
    const rowIndexAttr = rowElement?.getAttribute("data-p-index");
    const rowIndex = rowIndexAttr !== null ? Number(rowIndexAttr) : -1;
    if (rowIndex >= 0 && rowIndex <= 2) {
      return "down";
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }

    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;
    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event.stopPropagation();
    event.preventDefault();
    const targetElement = event.currentTarget;

    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const CellListDisplayFederal = (rowData, field) => {
    const categories = rowData[field]
      ? field === "federalCategories"
        ? rowData.businessCategory.map((ele) => ele.businessCategoryName)
        : rowData.businessCategory
          .filter((ele) => ele.state === rowData.stateInfo)
          .map((ele) => ele.businessCategoryName)
      : [];
    const firstCategory = categories[0] || "";
    const remainingCount = Math.max(categories.length - 1, 0);
    const hasValue = categories.length > 0;
    const hasMore = categories.length > 1;

    let name =
      field === "federalCategories"
        ? "Who Must File Federal"
        : "Who Must File in State";
    const overlayKey = `${field}-${rowData.workflowId || rowData.fileTrackingId || rowData.filingId}`;

    return (
      <div className="tableBtn" id={`${field}+${rowData.fileTrackingId}`}>
        <Button
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          text
          style={{ width: "100%", padding: 0, justifyContent: "flex-start" }}
        >
          <div
            style={{
              width: "100%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              whiteSpace: "nowrap",
              minWidth: 0,
            }}
          >
            <span
              style={{
                flex: "1 1 auto",
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: tableHeaderColor,
                textAlign: "left",
              }}
            >
              {firstCategory}
            </span>
            {hasMore && (
              <span
                style={{
                  flex: "0 0 auto",
                  fontSize: "12px",
                  color: tableHeaderColor,
                  whiteSpace: "nowrap",
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </Button>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            showCloseIcon
            dismissable
            className="client-profile-overlay-panel client-filing-master-approval-overlay-panel"
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            {name}
            <div className="overlay-scroll-consistent" style={{ width: "100%", maxWidth: "100%", maxHeight: "10.5rem", overflowY: "auto", overflowX: "hidden", paddingRight: "0.25rem", boxSizing: "border-box" }}>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {categories.map((ele, idx) => (
                  <li key={`${field}-${idx}`} style={{ marginBottom: "4px", overflowWrap: "anywhere" }}>
                    {ele}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const cellListDisplayName = (rowData) => {
    return (
      <LightTooltip title={rowData.filingName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: tableHeaderColor,
            cursor: "pointer",
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };
  const displayTimeStamp = (rowData) => {
    return rowData.recentDate ? toLocalDateTime(rowData.recentDate) : ""
  }
  const cellDisplayClientName = (rowData) => {
    return (
      <LightTooltip title={rowData.customerName}>
        <div
          style={{
            width: "inherit",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {rowData.customerName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);
    return (
      <LightTooltip title={ruleInfoValue}>
        <div
          style={{
            width: "12rem",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {ruleInfoValue}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "320px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: tableBackgroundColor,
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  const CustomCommentButton = ({ rowData }) => {
    const hasComments =
      rowData.hasComments === true ||
      rowData.hasComments === 1 ||
      rowData.hasComments === "1";
    const isActive = Boolean(hasComments);

    return (
      <IconButton
        size="small"
        disabled={!isActive}
        onClick={() => addComment(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          "&:hover": {
            backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          },
          pointerEvents: !isActive ? "none" : "auto",
          cursor: !isActive ? "default" : "pointer",
        }}
      >
        <GoogleMaterialIcon
          name="comment"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };

  const FilingAttachmentButton = ({ rowData }) => {
    const hasReference =
      rowData.hasReference === true ||
      rowData.hasReference === 1 ||
      rowData.hasReference === "1";
    const isActive = Boolean(hasReference);

    return (
      <IconButton
        size="small"
        disabled={!isActive}
        onClick={() => displayAttachments(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          "&:hover": {
            backgroundColor: isActive ? "color-mix(in srgb, var(--tn-primary-color, #432568) 12%, white)" : "#f5f5f5",
          },
          pointerEvents: !isActive ? "none" : "auto",
          cursor: !isActive ? "default" : "pointer",
        }}
      >
        <GoogleMaterialIcon
          name="snippet_folder"
          size={20}
          color={isActive ? tableHeaderColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };

  const closeAlert = () => {
    setShowAlert(false);
  };

  const updateSelectedWorkflow = (workflow) => {
    if (workflow) setSelectedFiling([workflow]);
    else setSelectedFiling([]);
  };

  const rowExpansionTemplate = (data) => {
    console.log("rowExpansionTemplate", data, data.filingPeriods);
    if (data.filingPeriods.length > 0) {
      let tableData = data.filingPeriods.map((ele) => {
        let startDate = new Date(ele.startDate);
        let endDate = new Date(ele.endDate);
        const toLocalDateString = date => date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

        let fp = `${toLocalDateString(startDate)} - ${toLocalDateString(endDate)}`;
        let dueDate = ele.dueDate !== null ? toLocalDateString(new Date(ele.dueDate)) : null;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: dueDate,
        };
      });
      console.log("rowExpansionTemplate", tableData);
      return (
        <div className="filingPeriodTable p-3" style={{ width: "50vw" }}>
          <h5>Due Dates for {data.filingName}</h5>
          <DataTable value={tableData}>
            <Column field="filingPeriod" header="Filing Period"></Column>
            <Column field="dueDate" header="DueDate"></Column>
          </DataTable>
        </div>
      );
    } else {
      return (
        <div className="filingPeriodTable p-3">
          <h5>No Due Dates for {data.filingName}</h5>
        </div>
      );
    }
  };

  const rowExpand = (event) => {
    console.log("rowExpand", event, expandedRows);
    // const newKeys =
    //   expandedRows !== null && expandedRows !== undefined
    //     ? Object.keys(event.data).filter(
    //         (key) => !expandedRows.hasOwnProperty(key)
    //       )[0]
    //     : Object.keys(event.data)[0];
    // let newExpanded = {};
    // newExpanded[newKeys] = event.data[newKeys];
    // console.log("rowExpand", newKeys, newExpanded);
    setExpandedRows(event.data);
  };

  const isExpandedParentRow = (rowData) => {
    if (!expandedRows || !rowData) return false;
    const rowKey = rowData.approvalListId;
    if (Array.isArray(expandedRows)) {
      return expandedRows.some((row) => row?.approvalListId === rowKey);
    }
    if (typeof expandedRows === "object") {
      return Object.prototype.hasOwnProperty.call(expandedRows, rowKey);
    }
    return false;
  };

  const onRowExpand = (event) => {
    console.log("rowExpand-->", event);
    getFilingPeriod(event.data);
  };

  const getFilingPeriod = async (data) => {
    console.log("@@Fetch getFilingPeriod", data?.filingId);
    try {
      const filingPeriod = await axios.get(
        `${API_BASE_URL}/FilingMaster/ListFilingMasterDraftPeriods/${data?.filingId}`
      );
      console.log("getFilingPeriod res", filingPeriod.data.data);
      let tableData = filingPeriod.data.data.map((ele) => {
        let fp = `${toLocalTime(ele.startDate)} - ${toLocalTime(ele.endDate)}`;
        return {
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: toLocalTime(ele.dueDate),
          initialDueDate: toLocalTime(ele.dueDate),
        };
      });
      console.log("getFilingPeriod tableData", tableData);
      setFilingPeriodTable(tableData);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yy");
      console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };

  const dt = useRef(null);
  const pageSize = 100;

  // lazy load function
  const loadDataLazy = async (event) => {
    console.log("loadDataLazy props", recordsInView, event);

    //Virtual scroll callback
    const vScroll = dt.current.getVirtualScroller()

    let range = vScroll.getRenderedRange();
    let { first, last } = range.viewport;
    console.log("loadDataLazy vScroll", vScroll, range.viewport);

    let firstVal = recordsInView * pageSize;
    let tableList = clientApprovalList;
    console.log(
      "loadDataLazy totalRecords",
      firstVal,
      totalRecords,
      lazyLoading,
      tableList.length
    );

    console.log(
      "loadDataLazy scroll check:",
      "first:", first,
      "tableList.length:", tableList.length,
      "threshold:", tableList.length - pageSize / 5,
      "firstVal:", firstVal,
      "totalRecords:", totalRecords,
      "lazyLoading:", lazyLoading
    );

    console.log(
      "loadDataLazy",
      firstVal < totalRecords,
      first > tableList.length - pageSize / 5,
      !lazyLoading
    );

    if (
      firstVal < totalRecords &&
      first > tableList.length - pageSize / 5 &&
      !lazyLoading
    ) {
      //scroll down
      // setIsLoading(true);
      setLazyLoading(true);
      let lastVal = firstVal + pageSize;
      console.log("loadDataLazy d firstVal", firstVal, lastVal);

      //get next data
      let records = await loadRecordsList(firstVal, lastVal, "down");
      console.log("loadDataLazy d record", records);
      if (records) {
        console.log("loadDataLazy d scrollInView", recordsInView * 100);

        //scroll to next records
        vScroll.scrollInView(recordsInView * 100);
        setRecordsInView((old) => old + 1);
        setLazyLoading(false);
        setIsLoading(false);
      }
    } else if (last < pageSize / 5 && recordsInView > 1 && !lazyLoading) {
      // scroll up
      let firstVal = (recordsInView - 3) * pageSize;
      let lastVal = firstVal + pageSize;
      if (firstVal >= 0) {
        // setIsLoading(true);
        setLazyLoading(true);
        // console.log("loadDataLazy u firstVal", firstVal, lastVal);

        //get prev data
        let records = await loadRecordsList(firstVal, lastVal, "up");
        // console.log("loadDataLazy u record", records);
        if (records) {
          // console.log("loadDataLazy u scrollInView", (recordsInView - 3) * 100);

          //scroll to prev records
          vScroll.scrollToIndex(pageSize * 1.5);
          setRecordsInView((old) => old - 1);
          setLazyLoading(false);
          setIsLoading(false);
        }
      }
    }
  };

  const loadRecordsList = async (first, last, direction) => {
    // console.log("loadRecordsList props", first, last, direction);
    setIsLoading(true);
    let url = `${API_BASE_URL}/Customer/CustomerFilingMasterWorkflowListbyPagination?StartRow=${first + 1}&EndRow=${last}&RecordType=TrackNow`

    // console.log("loadRecordsList fliter/sort", isFilterChange, sortingData);
    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      // url filter parameters
      isFilterChange.forEach((ele) => {
        url = `${url}&${ele.name}=${encodeURIComponent(ele.val)}${ele.searchType ? `&${ele.searchType}=${encodeURIComponent(ele.searchTypeVal)}` : ``
          }`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      // url sort parameters
      let sortParameter = getSortData(sortingData.sortBy);
      console.log("getSortData", sortParameter);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";

      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    // console.log("loadRecordsList url", url);
    try {
      //get data
      const res = await axios.get(url);
      console.log("loadRecordsList res", res.data, res.data.data.items);

      if (res.data) {
        setIsLoading(true);
        let ogList = clientApprovalList.map((ele) => ele);
        await modifyList(res.data.data.items, direction, ogList);
        setTotalRecords(res.data.data.totalItems);

        return res.data.data.items;
      } else {
        return false;
      }
    } catch (err) {
      // console.log("loadRecordsList err", err);
    }
  };

  //maping records for lazy load
  const modifyList = (list, direction, ogList) => {
    console.log("modifyList", list, direction);
    if (list.length > 0) {
      //list has data
      let fedLookup = [];
      let stateLookup = [];
      const updList = list
        .map((item, i) => {
          // console.log(`filtered data ...`, item);
          const _stateList = getStateName(item.stateInfo);
          const federalCategoryValues = _.map(
            item.businessCategory,
            "businessCategoryName"
          ).filter(Boolean);
          const stateCategoryValues = item.businessCategory
            .filter((ele) => ele.state ? ele.state === item.stateInfo : ele)
            .map((ele) => ele.businessCategoryName)
            .filter(Boolean);

          if (item.juristiction?.includes("Federal")) {
            fedLookup.push(
              ...federalCategoryValues
            );
            return {
              ...item,
              federalCategories: federalCategoryValues,
              stateCategories: [],
              stateList: _stateList,
              approvalListId: `${i}${item.workflowId}`
            };
          } else if (item.juristiction?.includes("Both")) {
            fedLookup.push(...federalCategoryValues);
            stateLookup.push(...stateCategoryValues);

            return {
              ...item,
              federalCategories: federalCategoryValues,
              stateCategories: stateCategoryValues,
              stateList: _stateList,
              approvalListId: `${i}${item.workflowId}`
            };
          } else {
            stateLookup.push(
              ...stateCategoryValues
            );

            return {
              ...item,
              federalCategories: [],
              stateCategories: stateCategoryValues,
              stateList: _stateList,
              approvalListId: `${i}${item.workflowId}`
            };
          }
        });

      const _jusrisdictions = updList.map((item) =>
        item.juristiction ? item.juristiction : ""
      );
      const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));

      setJurisdiction(_uniqJurisdictions);
      setFederalCategoriesLookup(Array.from(new Set(fedLookup)));
      setStateCategoriesLookup(Array.from(new Set(stateLookup)));

      let tableList = clientApprovalList;
      console.log("modifyList updCustomers", updList, tableList);

      let updFilingMastersList;
      if (direction === "down") {
        //scroll down
        if (tableList.length >= 200) {
          //list > 200

          //slice 2 half of list
          let unloadList = ogList.slice(
            ogList.length - pageSize,
            ogList.length
          );
          // console.log("modifyList dw unloadList", unloadList);

          //add new data
          updFilingMastersList = [...unloadList, ...updList];
        } else {
          //list < 200

          // add new data to list
          updFilingMastersList = [...ogList, ...updList];
        }
      } else if (direction === "up") {
        //scroll up
        if (tableList.length >= 200) {
          //list > 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
        } else {
          //list < 200

          //slice 1 half of list
          let unloadList = ogList.slice(0, pageSize);
          // console.log("modifyList up unloadList", unloadList);

          //add new data
          updFilingMastersList = [...updList, ...unloadList];
        }
      }

      setData(() => updFilingMastersList);
      setClientApprovalList(() => updFilingMastersList);
      setClientFilingMastersApprovalList(updFilingMastersList)
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      return updFilingMastersList;
    } else {
      //list empty
      // console.log("modifyList empty",list)
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      setClientApprovalList([]);
      setClientFilingMastersApprovalList([])
      return [];
    }
  };

  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        // console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `SearchByStateInfo`,
                  val: getStateCode(ele),
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `StateInfoSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `SearchByStateInfo`,
                val: getStateCode(e.filters[col].constraints[0].value),
                searchType: `StateInfoSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: e.filters[col].constraints[0].value,
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "customerName") {
            filterChange.push({
              name: `SearchByClientName`,
              val: e.filters[col].constraints[0].value,
              searchType: `ClientNameSearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          } else if (col === "juristiction") {
            filterChange.push({
              name: `SearchByJurisdiction`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (col === "required") {
            filterChange.push({
              name: `SearchByRequired`,
              val: e.filters[col].constraints[0].value,
            });
          } else if (col === "federalCategories") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `WhoMustFileFederal`,
                  val: ele,
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `WhoMustFileFederalSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `WhoMustFileFederal`,
                val: e.filters[col].constraints[0].value,
                searchType: `WhoMustFileFederalSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else if (col === "stateCategories") {
            Array.isArray(e.filters[col].constraints[0].value)
              ? e.filters[col].constraints[0].value.map((ele, i) => {
                let changeItem = {
                  name: `WhoMustFileInState`,
                  val: ele,
                };
                if (i + 1 === e.filters[col].constraints[0].value.length) {
                  changeItem.searchType = `WhoMustFileInStateSearchType`;
                  changeItem.searchTypeVal = getSearchType(
                    e.filters[col].constraints[0].matchMode
                  );
                }
                filterChange.push(changeItem);
              })
              : filterChange.push({
                name: `WhoMustFileInState`,
                val: e.filters[col].constraints[0].value,
                searchType: `WhoMustFileInStateSearchType`,
                searchTypeVal: getSearchType(
                  e.filters[col].constraints[0].matchMode
                ),
              });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: e.filters[col].constraints[0].value,
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(
                e.filters[col].constraints[0].matchMode
              ),
            });
          }
        }
      });
    }
    console.log("onFilterChange filterChange", filterChange);

    //set filter
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInView(0);
    setIsLoading(true);
    setData([]);
    setClientApprovalList([]);
  };

  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInView(0);
      setIsLoading(true);
      setData([]);
      setClientApprovalList([]);
    }
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrder",
      };
    } else {
      return {
        SortByParameter: "SortBy",
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: "SortOrder",
      };
    }
  };

  useEffect(() => {
    // console.log("filter/sort change", isFilterChange, sortingData, lazyLoading );
    //on filter/sort change
    if (!lazyLoading && !refreshRecordList) {
      setLazyLoading(true);
      const sortAndFilterApiCall = async () => {
        let records = await loadRecordsList(0, 100, "down");
        setRecordsInView(1);
        console.log("recordsCheck", records);
        setIsLoading(false);
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);

  const handleRefreshList = () => {

    //Virtual scroll callback
    const vScroll = dt.current.getVirtualScroller()
    let range = vScroll.getRenderedRange();
    console.log("refreshTable vScroll", vScroll, range);

    let pageInView
    let noOfPages
    if (clientApprovalList.length > 100) {
      pageInView = recordsInView - 2
      noOfPages = 2
    } else {
      pageInView = recordsInView - 1
      noOfPages = 1
    }
    let clientSelected = selectedFiling
    setRecordsInView(pageInView)
    setRefreshDetails({
      viewport: range.viewport,
      pageInView,
      noOfPages,
      clientSelected
    })

    // fetchFilingMasters();
    setIsLoading(true);
    setData([]);
    setClientApprovalList([]);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });
    setFederalFilterSelectedValues([]);
    setRefreshRecordList(true);
  }

  const refreshRecords = async () => {
    console.log("refreshRecords");

    //Virtual scroll callback
    const vScroll = dt.current.getVirtualScroller()
    let range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll", vScroll, range);


    let records
    console.log("refreshRecords refreshDetails", refreshDetails);
    if (refreshDetails?.pageInView || refreshDetails?.noOfPages) {
      let first = refreshDetails.pageInView * pageSize
      records = await loadRecordsList(first, first + refreshDetails?.noOfPages * pageSize, "down");
    } else {
      records = await loadRecordsList(0, pageSize, "down");
    }

    if (records) {
      console.log("refreshRecords refreshDetails", refreshDetails);
      if (refreshDetails?.viewport && refreshDetails?.noOfPages) {
        setRecordsInView((old) => old + refreshDetails?.noOfPages);
        // setRefreshDetails(null)
      } else {
        setRecordsInView((old) => old + 1);
      }
      setLazyLoading(false)
    }
  };

  useEffect(() => {
    console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords();
    }
  }, [refreshRecordList]);

  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    console.log("recordsInView,", recordsInView);
  }, [recordsInView]);

  useEffect(() => {
    console.log("pendingTableData,", clientApprovalList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    clientApprovalList,
    clientApprovalList.length,
    JSON.stringify(clientApprovalList),
  ]);

  useEffect(() => {
    console.log("isLoading", isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log("lazyLoading", lazyLoading);
  }, [lazyLoading]);

  return (
    <Fragment>
      <style>{`
  .p-datatable.frozen-client-approval {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tableBackgroundColor} !important;
  }

  .frozen-client-approval .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow-x: auto !important;
    overflow-y: auto !important;
    height: 550px !important;
    max-height: 550px !important;
    background: ${tableBackgroundColor} !important;
  }

  .frozen-client-approval .p-datatable-header {
    background: ${tableBackgroundColor} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .frozen-client-approval .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  /* HEADER */
  .frozen-client-approval .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-client-approval .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .frozen-client-approval .p-datatable-thead > tr > th {
    background: transparent !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 12px 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
  }

  .frozen-client-approval .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  /* Frozen columns z-index fix and dark purple background */
  .frozen-client-approval .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 2 !important;
    background: color-mix(in srgb, ${tableHeaderColor} 85%, black) !important;
    will-change: auto !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tableBackgroundColor} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tableBackgroundColor} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-client-approval .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .frozen-client-approval .p-datatable-tbody {
    background: ${tableBackgroundColor} !important;
  }

  .frozen-client-approval .p-virtualscroller-content {
    background: ${tableBackgroundColor} !important;
  }

  /* ROWS - Alternating colors with gridlines */
  .frozen-client-approval .p-datatable-tbody > tr {
    height: 45px !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:nth-child(odd) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:nth-child(even) > td {
    background-color: ${tableBackgroundColor} !important;
    padding: 0 12px !important;
    font-size: 15px !important;
    line-height: 1.2 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 45px !important;
    min-height: 45px !important;
    max-height: 45px !important;
    box-sizing: border-box !important;
  }

  /* FORCE PURPLE BORDERS ON ALL CELLS */
  .frozen-client-approval .p-datatable-tbody > tr > td {
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
    border-left: none !important;
    border-top: none !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* HOVER - Only for clickable cells */
  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn:hover,
  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 8%, white) !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.filingNameColumn:hover *,
  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.expandableColumn:hover * {
    font-weight: 600 !important;
    color: ${tableHeaderColor} !important;
  }

  /* Non-clickable cells - no hover effect */
  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn):not(.expandableColumn):hover {
    background-color: ${tableBackgroundColor} !important;
    font-weight: 400 !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion):not(.p-highlight) > td:not(.filingNameColumn):not(.expandableColumn):not(.indicatorsColumn):hover * {
    font-weight: 400 !important;
    color: #000000 !important;
  }

  /* Indicators column - no hover effect */
  .frozen-client-approval .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td.indicatorsColumn:hover {
    background-color: ${tableBackgroundColor} !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  /* Expanded parent row - disable hover effect entirely */
  .frozen-client-approval .p-datatable-tbody > tr.expanded-parent-row > td:hover {
    background-color: ${tableBackgroundColor} !important;
    cursor: default !important;
    border-right: 1px solid ${tableHeaderColor} !important;
    border-bottom: 1px solid ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr.expanded-parent-row > td:not(.indicatorsColumn):hover * {
    color: inherit !important;
    font-weight: inherit !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr.expanded-parent-row > td.filingNameColumn:hover,
  .frozen-client-approval .p-datatable-tbody > tr.expanded-parent-row > td.p-frozen-column:hover {
    background-color: ${tableBackgroundColor} !important;
    font-weight: 400 !important;
    cursor: default !important;
  }

  /* Expanded row nested table (Filing Period / DueDate) - no hover color shift */
  .frozen-client-approval .filingPeriodTable .p-datatable-tbody > tr > td:hover {
    background-color: ${tableBackgroundColor} !important;
    color: #000000 !important;
    font-weight: 400 !important;
  }

  /* Row expander: prevent parent table wrapper height from inflating nested table */
  .frozen-client-approval .filingPeriodTable .p-datatable-wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .frozen-client-approval .p-row-toggler {
    color: ${tableHeaderColor} !important;
    box-shadow: none !important;
  }

  .frozen-client-approval .p-row-toggler:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 12%, white) !important;
    color: ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-row-toggler:focus,
  .frozen-client-approval .p-row-toggler.p-focus {
    background-color: color-mix(in srgb, ${tableHeaderColor} 12%, white) !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .frozen-client-approval .filingPeriodTable .p-datatable-tbody > tr > td:hover * {
    color: #000000 !important;
    font-weight: 400 !important;
  }

  .frozen-client-approval .filingPeriodTable .p-datatable-thead > tr > th:hover,
  .frozen-client-approval .filingPeriodTable .p-datatable-thead > tr > th:hover * {
    color: #ffffff !important;
  }

  /* SELECTED ROW */
  .frozen-client-approval .p-datatable-tbody > tr.p-highlight > td {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  /* PrimeReact frozen columns keep their own background; force selection highlight on fixed cells too. */
  .frozen-client-approval .p-datatable-tbody > tr.p-highlight > td.p-frozen-column {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  .frozen-client-approval .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn,
  .frozen-client-approval .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn:hover {
    background-color: color-mix(in srgb, ${tableHeaderColor} 14%, white) !important;
  }

  .frozen-client-approval .p-selection-column {
    text-align: center !important;
  }

  .frozen-client-approval .p-selection-column .p-checkbox {
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }

  .p-checkbox .p-checkbox-box.p-highlight {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-checkbox .p-checkbox-box.p-focus,
  .frozen-client-approval .p-checkbox.p-focus .p-checkbox-box {
    border-color: ${tableHeaderColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${tableHeaderColor} 25%, white) !important;
  }

  .frozen-client-approval .p-datatable-loading-icon {
    color: ${tableHeaderColor} !important;
  }

  .frozen-client-approval .p-datatable-loading-icon svg {
    stroke: ${tableHeaderColor} !important;
  }

  .client-filing-master-approval-overlay-panel .p-overlaypanel-close,
  .client-filing-master-approval-overlay-panel .p-overlaypanel-close:hover {
    background: ${tableHeaderColor} !important;
    border-color: ${tableHeaderColor} !important;
  }

  .client-filing-master-approval-overlay-panel .p-overlaypanel-close .p-overlaypanel-close-icon,
  .client-filing-master-approval-overlay-panel .p-overlaypanel-close .pi,
  .client-filing-master-approval-overlay-panel .p-overlaypanel-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  /* SCROLLBAR (scoped) */
  .frozen-client-approval .p-datatable-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .frozen-client-approval .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .frozen-client-approval .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${tableHeaderColor};
  }

  .filingPeriodTable .p-datatable-thead > tr {
    background: ${tableHeaderColor} !important;
  }
`}</style>
      <ApproveClientFilingMaster
        show={showFilter}
        dockAt="right"
        drafts={selectedFiling}
        handleClose={closeFilter}
        updateSelectedWorkflow={updateSelectedWorkflow}
        refreshList={handleRefreshList}
      />
      {isLoading && (
        <CircularProgress
          sx={{ position: 'fixed', top: '50%', left: '50%', zIndex: 9999, color: tableHeaderColor }}
        />
      )}
      <Box sx={{ display: "flex", alignItems: "flex-start", width: "100%" }}>
        <Grid sx={{ height: "100%", width: isMobile ? "100%" : "93%" }}>
          <div
            className="card clientFilingMasterApproval"
            style={{
              maxWidth: "90vw",
              padding: "1rem",
              margin: "1rem",
              background: containerBackgroundColor,
              borderRadius: "8px",
              overflow: "visible",
              border: "none",
            }}
          >
            <DataTable
              ref={dt}
              className="frozen-client-approval"
              scrollable
              resizableColumns
              showGridlines
              emptyMessage="No records found"
              value={clientApprovalList}
              selection={selectedFiling}
              onSelectionChange={(e) => setSelectedFiling(e.value)}
              dataKey="approvalListId"
              style={{ minHeight: "50vh" }}
              onRowSelect={onRowSelect}
              onRowToggle={(e) => rowExpand(e)}
              rowExpansionTemplate={rowExpansionTemplate}
              expandedRows={expandedRows}
              rowClassName={(rowData) =>
                isExpandedParentRow(rowData) ? "expanded-parent-row" : ""
              }
              loading={isLoading}
              // rows={viewAll ? clientApprovalList.length : 10}
              // rowsPerPageOptions={[5, 10, 25, 50]}
              // paginator={!viewAll}
              header={header}
              virtualScrollerOptions={{
                onScroll: loadDataLazy,
                itemSize: 45,
                delay: 0,
                scrollHeight: "550px",
                appendOnly: true,
              }}
              scrollHeight="550px"
              sortField={sortingData.sortBy}
              sortOrder={sortingData.sortOrder}
              onSort={(e) => handleSort(e)}
            >
              <Column expander={true} style={{ width: "5rem" }} />
              <Column
                selectionMode="multiple"
                headerStyle={{ width: "3rem" }}
              >
                Select
              </Column>
              <Column
                frozen={enableForzen}

                body={(rowData) => (
                  <>
                    <Stack direction="row">
                      <CustomCommentButton rowData={rowData} />
                      <FilingAttachmentButton rowData={rowData} />
                    </Stack>
                  </>
                )}
                header="Indicators"
                className="indicatorsColumn"
                style={{ textAlign: "center" }}
              ></Column>
              <Column
                field="approverName"
                header="Approver Name"
                sortable
                frozen={enableForzen}

                style={{ minWidth: "15rem" }}
              ></Column>
              <Column
                field="filingName"
                header="Filing Name"
                sortable
                frozen={enableForzen}

                className="filingNameColumn"
                style={{ minWidth: "12rem", maxWidth: "25rem" }}
                body={(rowData) => cellListDisplayName(rowData)}
              ></Column>
              <Column
                field="recentDate"
                header="Time Stamp"
                sortable
                style={{ minWidth: "15rem" }}
                frozen={enableForzen}

                body={displayTimeStamp}
              ></Column>
              <Column
                field="customerName"
                header="Client Name"
                sortable
                style={{ minWidth: "11rem", maxWidth: "11rem" }}
                body={(rowData) => cellDisplayClientName(rowData)}
              ></Column>

              {/* <Column
                    field='filingDescription'
                    header='Filing Description'
                    sortable
                    filter
                    filterPlaceholder='Search by Description'
                    style={{ minWidth: "15rem" }}
                  ></Column> */}
              <Column
                field="filingFrequency"
                header="Filing Frequency"
                style={{ minWidth: "15rem" }}
              ></Column>
              {/* <Column
                    field='dueDayofFrequency'
                    header='Due Date Offset'
                    filter
                    filterPlaceholder='Search by Frequency'
                    style={{ minWidth: "15rem" }}
                  ></Column> */}
              <Column
                field="stateList"
                header="State"
                style={{ minWidth: "13rem" }}
                className="column-small"
              ></Column>
              <Column
                field="ruleInfo"
                header="Rule Info"
                style={{ minWidth: "15rem", maxWidth: "15rem" }}
                body={(rowData) => cellListDisplayRuleInfo(rowData)}
              ></Column>
              <Column
                field="required"
                header="Mandatory"
                style={{ minWidth: "13rem" }}
              ></Column>
              <Column
                field="federalCategories"
                header="Who Must File Federal"
                className="expandableColumn"
                body={(rowData) =>
                  CellListDisplayFederal(rowData, "federalCategories")
                }
                style={{ minWidth: "20rem", maxWidth: "20rem" }}
              ></Column>
              <Column
                field="stateCategories"
                header="Who Must File in State"
                className="expandableColumn"
                body={(rowData) =>
                  CellListDisplayFederal(rowData, "stateCategories")
                }
                style={{ minWidth: "20rem", maxWidth: "20rem" }}
              ></Column>
              {/* <Column
                    field='jsidept'
                    header='JSI Dept'
                    filter
                    filterPlaceholder='Search by dept'
                    style={{ minWidth: "15rem" }}
                  ></Column> */}
              <Column
                field="jsicontactName"
                header="JSI Staff"
                style={{ minWidth: "15rem" }}
              ></Column>
              {/* <Column
                    field='jsicontactEmail'
                    header='JSI Contact Email'
                    filter
                    filterPlaceholder='Search by contactEmail'
                    style={{ minWidth: "15rem" }}
                  ></Column> */}
              <Column
                field="juristiction"
                header="Jurisdiction"
                sortable
                style={{ minWidth: "14rem" }}
              ></Column>
              <Column
                field="notes"
                header="Notes"
                style={{ minWidth: "21rem", maxWidth: "21rem" }}
                body={(rowData) => cellListDisplayNotes(rowData)}
              ></Column>
            </DataTable>
          </div>
        </Grid>

        <Grid
          sx={{
            display: isMobile ? "none" : "block",
            height: "100%",
            width: "5%",
            position: "sticky",
            top: 10,
            alignSelf: "flex-start",
            zIndex: 2,
          }}
        >
          <div style={{ height: "100%", background: "transparent", marginTop: 0 }}>
            <Item
              sx={{
                height: "100%",
                background: "transparent",
                boxShadow: "none",
                borderRadius: "50px",
                overflow: "visible",
              }}
            >
              <ApproveToolbox
                isLoading={isLoading}
                addComment={addComment}
                approveDraft={approveDraft}
                displayAttachments={displayAttachments}
              />
            </Item>
          </div>
        </Grid>
      </Box>
      <CustomDialog
        header="Selection Required"
        visible={showAlert}
        onHide={closeAlert}
        icon="⚠️"
      >
        {alertMessage}
      </CustomDialog>
      {
        <ClientFilingMasterWorkflowComments
          show={showComments}
          dockAt="right"
          workflow={selectedFiling[0]}
          rowData={selectedRowData}
          comments={comments}
          handleClose={closeComments}
          refreshList={handleRefreshList}
        />
      }
      {
        <ClientFilingMasterReferenceDocuments
          show={showAttachments}
          dockAt="right"
          filing={selectedFiling[0]}
          attachments={attachments}
          handleClose={closeAttachments}
        />
      }
      <Popover
        open={Boolean(filterAnchorEl)}
        anchorEl={filterAnchorEl}
        onClose={handleFilterClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        PaperProps={{
          sx: {
            backgroundColor: tokens.colors.offWhite,
            border: "1px solid #ccc",
          },
        }}
      >
        <Box sx={{ p: 2, width: 350, maxHeight: 500, overflowY: "auto" }}>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>
            Filter
          </Typography>

          <TextField
            select
            fullWidth
            label="Column"
            size="small"
            value={selectedFilterColumn}
            onChange={(e) => {
              setSelectedFilterColumn(e.target.value);
              setSelectedFilterValue("");
              setSelectedFilterCondition("");
            }}
          >
            {filterableColumns.map((column) => (
              <MenuItem key={column.value} value={column.value}>
                {column.label}
              </MenuItem>
            ))}
          </TextField>

          {selectedFilterColumn && (
            <TextField
              select
              fullWidth
              label="Condition"
              size="small"
              sx={{ mt: 2 }}
              value={selectedFilterCondition}
              onChange={(e) => {
                const nextCondition = e.target.value;
                setSelectedFilterCondition(nextCondition);
                setSelectedFilterValue(
                  shouldUseMultiSelectFilterValue(selectedFilterColumn, nextCondition)
                    ? []
                    : ""
                );
              }}
            >
              {selectedFilterColumn !== "required" && selectedFilterColumn !== "juristiction" && (
                <MenuItem value={FilterMatchMode.CONTAINS}>Contains</MenuItem>
              )}
              {selectedFilterColumn !== "required" && selectedFilterColumn !== "juristiction" && (
                <MenuItem value={FilterMatchMode.NOT_CONTAINS}>Is Not</MenuItem>
              )}
              <MenuItem value={FilterMatchMode.EQUALS}>Is</MenuItem>
            </TextField>
          )}

          {selectedFilterColumn && selectedFilterCondition && (
            (
              getFilterValueOptions(selectedFilterColumn).length > 0 ||
              selectedFilterColumn === "federalCategories" ||
              selectedFilterColumn === "stateCategories"
            ) ? (
              shouldUseMultiSelectFilterValue(selectedFilterColumn, selectedFilterCondition) ? (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Select Values:</Typography>
                  <Box sx={{
                    maxHeight: 200,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 1,
                    backgroundColor: tokens.colors.offWhite
                  }}>
                    <FormGroup>
                      {getFilterValueOptions(selectedFilterColumn).map((option) => (
                        <FormControlLabel
                          key={option}
                          control={
                            <Checkbox
                              checked={Array.isArray(selectedFilterValue) && selectedFilterValue.includes(option)}
                              onChange={() => {
                                const currentValues = Array.isArray(selectedFilterValue) ? selectedFilterValue : [];
                                const nextValues = currentValues.includes(option)
                                  ? currentValues.filter((value) => value !== option)
                                  : [...currentValues, option];
                                setSelectedFilterValue(nextValues);
                              }}
                              size="small"
                            />
                          }
                          label={option}
                          sx={{
                            fontSize: "14px",
                            "& .MuiFormControlLabel-label": { fontSize: "14px" },
                            mb: 0.5
                          }}
                        />
                      ))}
                    </FormGroup>
                  </Box>
                </Box>
              ) : shouldUseRadioFilterValue(selectedFilterColumn, selectedFilterCondition) ? (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" sx={{ mb: 1 }}>Select Value:</Typography>
                  <Box sx={{
                    maxHeight: 200,
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    p: 1,
                    backgroundColor: tokens.colors.offWhite
                  }}>
                    <RadioGroup
                      value={Array.isArray(selectedFilterValue) ? "" : selectedFilterValue}
                      onChange={(e) => setSelectedFilterValue(e.target.value)}
                    >
                      {getFilterValueOptions(selectedFilterColumn).map((option) => (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={<Radio size="small" />}
                          label={option}
                          sx={{
                            fontSize: "14px",
                            "& .MuiFormControlLabel-label": { fontSize: "14px" },
                            mb: 0.5
                          }}
                        />
                      ))}
                    </RadioGroup>
                  </Box>
                </Box>
              ) : (
                <TextField
                  select
                  fullWidth
                  label="Value"
                  size="small"
                  sx={{ mt: 2 }}
                  value={Array.isArray(selectedFilterValue) ? "" : selectedFilterValue}
                  onChange={(e) => setSelectedFilterValue(e.target.value)}
                >
                  {getFilterValueOptions(selectedFilterColumn).map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              )
            ) : (
              <TextField
                fullWidth
                label="Value"
                size="small"
                sx={{ mt: 2 }}
                value={Array.isArray(selectedFilterValue) ? "" : selectedFilterValue}
                onChange={(e) => setSelectedFilterValue(e.target.value)}
              />
            )
          )}

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <TrackNowButton size="small" variant="secondary" onClick={handleFilterClear}>
              Clear
            </TrackNowButton>
            <TrackNowButton size="small" variant="primary" onClick={applyFilterFromPopover}>
              Apply Filter
            </TrackNowButton>
          </Box>
        </Box>
      </Popover>
    </Fragment>
  );
};

export default ClientFilingMasterApprovalList;
